import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["type", "disabled"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'BaseButton',
    props: {
        variant: { default: "primary" },
        block: { type: Boolean, default: false },
        type: { default: "button" },
        disabled: { type: Boolean, default: false }
    },
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["df-btn", [`df-btn--${__props.variant}`, { 'df-btn--block': __props.block }]]),
                type: __props.type,
                disabled: __props.disabled
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
